import { cloneDeep } from 'lodash'
import { CHANGE_PAGE, SET_EVENTS_FILTER, SET_EVENT_VIEW_TYPE } from '../events/types'
import {
  SET_USER,
  SET_SECURITY_ROLES,
  SET_CONTENT_GROUPS,
  UPDATE_ROLE,
  UPDATE_SECURITY_ROLE_USERS,
  CREATE_ROLE,
  UPDATE_USER_ROLE,
  DELETE_SECURITY_ROLE,
  GET_CATEGORIES,
  CREATE_CONTENT_GROUP,
  ADD_CONTENT_GROUP_CATEGORIES,
  REMOVE_CONTENT_GROUP_CATEGORIES,
  UPDATE_CONTENT_GROUP_META,
  ADD_CONTENT_GROUP_USER,
  REMOVE_CONTENT_GROUP_USER,
  GET_USERS,
  DELETE_CONTENT_GROUP,
  SET_WEBSOCKET,
  GET_EVENTS_SLIM,
  GET_EVENTS_ANALYTICS,
  GET_FULL_EVENT,
  GET_TRANSCRIPT_VOCABULARIES,
  UPDATE_TRANSCRIPT_VOCABULARIES,
  SET_CLIENT,
  GET_ENCODERS,
  GET_EVENTS,
  GET_PLAYER_PREFERENCES,
  GET_EVENT_LOG_ITEMS,
  STARTED_REQUESTING_EVENT_LOG_ITEMS,
  FINISHED_REQUESTING_EVENT_LOG_ITEMS
} from './types'

export const getInitialState = () => ({
  eventAnalytics: {},
  events: {},
  eventLogItems: {},
  eventsMeta: null,
  eventTargetDestinations: {},
  eventTranscripts: {},
  eventAudioDescriptions: {},
  users: [],
  categories: null,
  encoders: null,
  user: null,
  securityRoles: null,
  contentGroups: null,
  websocket: null,
  pending: true,
  playerPreferences: null,
  vocab: null
})

const setKey = (state, value, key) => {
  const newState = {
    ...state,
    [key]: cloneDeep(value),
  }
  if (newState.user && newState.securityRoles && newState.contentGroups) {
    //@FIXME: refactor this to use the requests reducer
    // requires refactoring login
    newState.pending = false
  }
  return newState
}

//#region custom handlers

const updateUser = (state, user) => {
  const newUsers = [...state.users]
  if (user) {
    // find and replace the updated user
    for (let i = 0; i < state.users.length; i++) {
      const theUser = state.users[i]
      if (theUser.userId === user.userId) {
        newUsers[i] = { ...theUser, ...user }
      }
    }
  }
  return { ...state, users: newUsers }
}

const userCreated = (state, user) => {
  const userIds = {}
  return {
    ...state,
    users: [...state.users, user].filter((user) => {
      // add the user then remove any duplicated users caused by earlier ws message or callback
      if (userIds[user.userId]) {
        return false
      } else {
        userIds[user.userId] = true
        return true
      }
    }),
  }
}

const handleGetUsers = (state, action) => {
  const users = action.payload[1].data
  if (Array.isArray(users)) {
    return setKey(state, users, 'users')
  } else {
    // some users get requests return just thisUser, don't replace the users state
    // with anything but an array or users
    return state
  }
}

const handleRemoveUser = (state, deletedUser) => {
  return {
    ...state,
    users: state.users.filter((user) => user.userId !== deletedUser.userId),
  }
}

const addNewUser = (state, action) => {
  const user = action.payload[1].data
  if (user) {
    return [...state, user]
  }
  return state
}

const updateContentGroupCategories = (state, payload) => {
  const updatedGroupId = payload.postData.groupID
  const newState = cloneDeep(state)
  const updatedGroup = newState.contentGroups.find(
    (contentGroup) => contentGroup.Group.groupID === updatedGroupId
  )
  if (!updatedGroupId || !updatedGroup) {
    // the edited group couldn't be found, ignore the category updates for that group
    return state
  }
  updatedGroup.GroupCategories = payload.res.data.data
  return newState
}

const updateContentGroupMeta = (state, payload) => {
  const updatedGroupId = payload.postData.groupID
  if (!updatedGroupId) return state
  const newState = cloneDeep(state)
  newState.contentGroups = []
  for (let i = 0; i < state.contentGroups.length; i++) {
    const contentGroup = state.contentGroups[i]
    // find and replace updated group
    if (contentGroup.Group.groupID !== updatedGroupId) {
      newState.contentGroups.push(contentGroup)
    } else {
      newState.contentGroups.push(payload.res.data.data[0])
    }
  }
  return newState
}

const updateGroupUsers = (state, action) => {
  const groupID = action.payload.postData.groupID
  const users = action.payload.res.data.data
  const newState = cloneDeep(state)
  newState.contentGroups = []
  for (let i = 0; i < state.contentGroups.length; i++) {
    const contentGroup = state.contentGroups[i]
    if (contentGroup.Group.groupID !== groupID) {
      newState.contentGroups.push(contentGroup)
    } else {
      newState.contentGroups.push({
        ...contentGroup,
        GroupUsers: users,
      })
    }
  }
  return newState
}

const removeGroupUser = (state, action) => {
  const groupID = action.payload.postData.groupID
  const newState = cloneDeep(state)
  newState.contentGroups = []
  for (let i = 0; i < state.contentGroups.length; i++) {
    const contentGroup = state.contentGroups[i]
    if (contentGroup.Group.groupID !== groupID) {
      newState.contentGroups.push(contentGroup)
    } else {
      newState.contentGroups.push({
        ...contentGroup,
        GroupUsers: contentGroup.GroupUsers.filter(
          (user) => user.userId !== action.payload.postData.userID
        ),
      })
    }
  }
  return newState
}

const deleteContentGroup = (state, action) => {
  return {
    ...state,
    contentGroups: [
      ...state.contentGroups.filter(
        (group) => group.Group.groupID !== action.payload.postData.groupID
      ),
    ],
  }
}

const getVocabs = (state, action) => {
  return {
    ...state,
    vocab: action.payload.res.data.data
  }
}

const updateEventsAnalytics = (state, action) => {
  const newEventAnalytics = {}
  //newEventAnalytics[event.eventID] = action.payload.res.data.result
  action.payload.res.data.result.forEach((event) => {
    //event.ActivePlayers = action.payload.res.data.result.ActivePlayers;
    newEventAnalytics[event.eventID] = event;
  })
  return {
    ...state,
    eventAnalytics: {
      ...state.eventAnalytics,
      ...newEventAnalytics,
    },
  }
}

const addEvents = (state, events, meta, isSlim) => {
  const newEvents = {...state.events}
  events.forEach(event => {
    if (event && event.eventID) {
      newEvents[event.eventID] = event
      newEvents[event.eventID].isSlim = isSlim
    }
  })
  return {
    ...state,
    events: newEvents,
    eventsMeta: meta || state.eventsMeta
  }
}

const addEvent = (state, event) => {
  return addEvents(state, [event])
}

const clearEvents = (state, action) => {
  return {
    ...state,
    events: {}
  }
}

const updateVocab = (state, vocab) => {
  if (state.vocab === null) {
    // if vocab is null set vocab with the incoming data as the first vocabulary in the array
    return {
      ...state,
      vocab: [vocab]
    }
  } else {
    // replace the existing vocab with the same idx if there is a matching one
    const newVocab = [...state.vocab]
    for (let i = 0; i < state.vocab.length; i++) {
      if (state.vocab[i].vocabIdx === vocab.vocabIdx) {
        newVocab[i] = vocab
        break
      }
    }
    return {
      ...state,
      vocab: newVocab
    }
  }
}

const eventWebsocketUpdate = (state, updatedEvent) => {

  /**
   * If the socket comes from the logger ignore it
   * This is either
   * - `logSource: <String>`
   * - `deletedID: <String>`
   * - `sendOne: <Bool>`
   */
  if (updatedEvent.logSource || updatedEvent.deletedID || updatedEvent.sendOne || updatedEvent.currentItemID) return state

  const eventID = updatedEvent.eventID
  return {
  ...state,
    events: {
      ...state.events,
      [eventID]: updatedEvent
    }
  }
}

const eventWebsocketDelete = (state, deletedEventID) => {
  const newState = {...state}
  delete newState.events[deletedEventID]
  return newState
}

const encoderUpdate = (state, updatedEncoder) => {
  // find the encoder that was updated if it is already loaded
  let newEncoders = [...state.encoders]
  const oldEncoderIndex = newEncoders.findIndex(encoder => encoder.encoderID === updatedEncoder.encoderID)
  if (oldEncoderIndex >= 0) {
    newEncoders[oldEncoderIndex] = updatedEncoder
  } else {
    newEncoders = [...newEncoders, updatedEncoder]
  }

  return {
    ...state,
    encoders: newEncoders
  }
}

const removeAssetFromEvent = (state, assetID, eventID) => {
  const event = state.events[eventID]
  if (!event) return state
  const newAssets = [...event.mediaAssets]
  // remove the asset
  newAssets.splice(newAssets.findIndex(asset => asset.assetID === assetID), 1)
  return {
    ...state,
    events: {
      ...state.events,
      [eventID]: {
        ...event,
        mediaAssets: newAssets
      }
    }
  }
}
const addOrUpdateEventAsset = (state, assets) => {
  // console.log('__addOrUpdateEventAsset__', assets);
  // console.log('__state__', state);

  if (!Array.isArray(assets)) {
    assets = [assets]
  }

  let newState = state
  assets.forEach(asset => {
    const eventID = asset.eventID
    if (eventID && state.events[eventID] && state.events[eventID].mediaAssets) {
      // remove an asset being updated
      const existingAssetIndex = newState.events[eventID].mediaAssets.findIndex(eventAsset => {
        return eventAsset.assetID === asset.assetID || (eventAsset.currentStatus === 'placeholder' && eventAsset.name === asset.name)
      })
      if (existingAssetIndex !== -1) {
        // replace the index of the media asset with the matching assetID / placeholder
        newState.events[eventID].mediaAssets.splice(existingAssetIndex, 1, asset)
      } else {
        newState.events[eventID].mediaAssets = [...newState.events[eventID].mediaAssets, asset]
      }
      newState = {
        ...newState,
        events: {
          ...newState.events,
          [eventID]: {
            ...newState.events[eventID],
            mediaAssets: [...newState.events[eventID].mediaAssets]
          }
        }
      }
    }
  })

  return newState
}

const updateEventRestrictedDomains = (state, action) => {
  const { eventID, restrictedDomains } = action.payload.data
  if (state.events[eventID]) {
    // event exists to update its restrictedDomains
    return {
      ...state,
      events: {
        ...state.events,
        [eventID]: {
          ...state.events[eventID],
          restrictedDomains
        }
      }
    }
  }
  // event that was updated wasn't loaded
  return state
}

const updateAssetTranscodeProgress = (state, transcodeProgress) => {
  const { eventID, assetID } = transcodeProgress
  // merge the existing asset with this transcode progress and use the asset update handler
  if (state.events[eventID] && state.events[eventID].mediaAssets) {
    const newAsset = state.events[eventID].mediaAssets.find(eventAsset => eventAsset.assetID === assetID)
    if (newAsset) {
      newAsset.transcodeProgress = transcodeProgress
      // newAsset.currentStatus = 'publishing' // make sure the status isn't cue if we have progress
      return addOrUpdateEventAsset(state, newAsset)
    }
  }
  // event wasn't fully loaded or asset wasn't set so there is nothing to update
  return state
}

const addOrUpdateEventStreamTargets = (state, targets) => {
  if (!targets) return state
  if (!Array.isArray(targets)) {
    targets = [targets]
  }
  if (!targets.length) return state

  const newState = {...state}
  const eventID = targets[0].eventID.split('_')[1]
  targets.forEach(target => {
    if (!newState.eventTargetDestinations[eventID]) {
      //setup property to hold event target info before adding them
      newState.eventTargetDestinations[eventID] = []
    }
    // check if this target was already added and replace it or add it
    const existingIndex = newState.eventTargetDestinations[eventID].findIndex(eventTarget => eventTarget.altEventStreamID === target.altEventStreamID)
    if (existingIndex !== -1) {
      //replace existing stream
      newState.eventTargetDestinations[eventID].splice(existingIndex, 1, target)
    } else {
      // add newly added target
      newState.eventTargetDestinations[eventID] = [...newState.eventTargetDestinations[eventID], target]
    }
  })
  return {
    ...state,
    eventTargetDestinations: {
      ...state.eventTargetDestinations,
      [eventID]: newState.eventTargetDestinations[eventID]
    }
  }
}

const removeEventStreamTarget = (state, eventID, removedAltStreamID) => {
  eventID = eventID.split('_')[1]
  const newEventTargetDestinations = [...state.eventTargetDestinations[eventID]]
  const removedIndex = newEventTargetDestinations.findIndex(eventTarget => eventTarget.altEventStreamID === removedAltStreamID)
  if (removedIndex !== -1) {
    newEventTargetDestinations.splice(removedIndex, 1)
  }
  return {
    ...state,
    eventTargetDestinations: {
      ...state.eventTargetDestinations,
      [eventID]: newEventTargetDestinations
    }
  }
}

const updateEventTranscripts = (state, transcript, eventID) => {
  if (!eventID && transcript.eventID) {
    eventID = transcript.eventID.split('_')[1]
  }
  if (state.events[eventID]) {
    return {
      ...state,
      eventTranscripts: {
        ...state.eventTranscripts,
        [eventID]: transcript
      }
    }
  }
  return state
}

const deleteEventTranscripts = (state, action) => {
  const eventID = action.payload.data.eventID.split('_')[1]
  const newTranscriptState = {...state.eventTranscripts}
  if (state.eventTranscripts[eventID]) {
    delete newTranscriptState[eventID]
  }
  return {
    ...state,
    eventTranscripts: newTranscriptState
  }
}

const updateEventAudioDescription = (state, project) => {
  if (!project) {
    logAd('upsert dropped: no project payload')
    return state
  }
  if (!project.eventID) {
    logAd('upsert dropped: missing eventID', { id: project.id })
    return state
  }
  const manifest = typeof project.manifest === 'string'
    ? safeJsonParse(project.manifest)
    : project.manifest

  const prev = state.eventAudioDescriptions[project.eventID]
  const prevStatus = (prev && prev.manifest && prev.manifest.status) || {}
  const nextStatus = (manifest && manifest.status) || {}
  const descCount = (manifest && Array.isArray(manifest.audioDescriptions))
    ? manifest.audioDescriptions.length
    : 0
  logAd('upsert', {
    eventID: project.eventID,
    projectID: project.id,
    revision: prev ? `${prev.revision} → ${project.revision}` : project.revision,
    lifecycle: `${prevStatus.lifecycle || 'n/a'} → ${nextStatus.lifecycle || 'n/a'}`,
    processing: `${prevStatus.processing || 'n/a'} → ${nextStatus.processing || 'n/a'}`,
    descriptionCount: descCount,
    statusBlockPresent: Boolean(manifest && manifest.status)
  })

  return {
    ...state,
    eventAudioDescriptions: {
      ...state.eventAudioDescriptions,
      [project.eventID]: { ...project, manifest }
    }
  }
}

const removeEventAudioDescription = (state, project) => {
  if (!project || !project.eventID) {
    logAd('delete dropped: missing eventID')
    return state
  }
  if (!state.eventAudioDescriptions[project.eventID]) {
    logAd('delete dropped: no record for eventID', { eventID: project.eventID })
    return state
  }
  logAd('delete', { eventID: project.eventID, projectID: project.id })
  const next = { ...state.eventAudioDescriptions }
  delete next[project.eventID]
  return { ...state, eventAudioDescriptions: next }
}

const safeJsonParse = (s) => {
  try { return JSON.parse(s) } catch (_) { return null }
}

// Single-purpose console logger for AD project websocket flow. Stays on in
// every environment so we can debug missed updates from staging/prod consoles
// without a rebuild. Cheap (a few keys per ws message), and visually scoped
// with the [AD-WS] prefix so it doesn't pollute general logs.
const logAd = (label, fields) => {
  if (typeof console === 'undefined') return
  if (fields) {
    console.log('[AD-WS]', label, fields)
  } else {
    console.log('[AD-WS]', label)
  }
}

const addEventLogItems = (state, action) => {
  const { logSource, logItems } = action.payload.res.data.data
  const eventID = action.payload.postData.eventID
  if (!logItems) {
    return state
  }

  // initialize the logItems for an event that hasn't been added yet
  if (!state.eventLogItems[eventID]) {
    return {
      ...state,
      eventLogItems: {
        ...state.eventLogItems,
        [eventID]: {
          [logSource]: logItems
        }
      }
    }
  }
  // replace or add log items for an event that has been added
  return {
    ...state,
    eventLogItems: {
      ...state.eventLogItems,
      [eventID]: {
        ...state.eventLogItems[eventID],
        [logSource]: logItems
      }
    }
  }
}


//#endregion

//#region handlers
const FETCH_SUCCESS = '_FETCH_SUCCESS'
const WEBSOCKET_DATA = 'WEBSOCKET_DATA_'
const BUS = 'BUS/'
const API_REQUEST = 'API_REQUEST_'
const FETCH_RESPONSE = '_FETCH_RESPONSE'

const actionHandlers = {
  [SET_WEBSOCKET]: (state, action) => setKey(state, action.payload.websocket, 'websocket'),
  [SET_USER]: (state, action) => setKey(state, action.payload.user, 'user'),
  [SET_CLIENT]: (state, action) => setKey(state, action.payload.client, 'client'),
  [SET_SECURITY_ROLES]: (state, action) =>
    setKey(state, action.payload.securityRoles, 'securityRoles'),
  [SET_CONTENT_GROUPS]: (state, action) =>
    setKey(state, action.payload.contentGroups, 'contentGroups'),
  [SET_EVENTS_FILTER]: clearEvents,
  [CHANGE_PAGE]: clearEvents,
  [`${BUS}filterChange`]: clearEvents,
  [`${BUS}quickFilter`]: clearEvents,
  [`${BUS}http.events.get.start`]: clearEvents,
  [SET_EVENT_VIEW_TYPE]: clearEvents,
  [STARTED_REQUESTING_EVENT_LOG_ITEMS]: (state) => setKey(state, true, 'isRequestingEventLogItems'),
  [FINISHED_REQUESTING_EVENT_LOG_ITEMS]: (state) => setKey(state, false, 'isRequestingEventLogItems'),
}

const handleAddEvent = (state, eventData) => {
  //if there were events in the response, add them to the state
  // eventData may be undefined if there was no events in the response
  if (eventData === undefined) return state
  return {
    ...state,
    [eventData.eventID]: eventData
  }
}

const requestHandlers = {
  [`${UPDATE_USER_ROLE}${FETCH_SUCCESS}`]: (state, action) =>
    updateUser(state, action.payload.res.data.data.users),
  [`${UPDATE_ROLE}${FETCH_SUCCESS}`]: (state, action) =>
    setKey(state, action.payload.res.data.data.roles, 'securityRoles'),
  [`${CREATE_ROLE}${FETCH_SUCCESS}`]: (state, action) =>
    setKey(state, action.payload.res.data.data.roles, 'securityRoles'),
  [`${UPDATE_SECURITY_ROLE_USERS}${FETCH_SUCCESS}`]: (state, action) =>
    setKey(state, action.payload.res.data.data.roles, 'securityRoles'),
  [`${DELETE_SECURITY_ROLE}${FETCH_SUCCESS}`]: (state, action) =>
    setKey(state, action.payload.res.data.data.roles, 'securityRoles'),
  [`${API_REQUEST}events_get${FETCH_RESPONSE}`]: (state, action) => handleAddEvent(state, action.payload[1].data[0]),
  [`${API_REQUEST}users_delete${FETCH_RESPONSE}`]: (state, action) =>
    handleRemoveUser(state, action.payload[1].data),
  [`${API_REQUEST}users_get${FETCH_RESPONSE}`]: handleGetUsers,
  [`${API_REQUEST}users_add${FETCH_RESPONSE}`]: addNewUser,
  [`${API_REQUEST}categories_get${FETCH_RESPONSE}`]: (state, action) =>
    setKey(state, action.payload[1].data, 'categories'),
  [`${GET_CATEGORIES}${FETCH_SUCCESS}`]: (state, action) =>
    setKey(state, action.payload.res.data.data, 'categories'),
  [`${CREATE_CONTENT_GROUP}${FETCH_SUCCESS}`]: (state, action) =>
    setKey(state, action.payload.res.data.data, 'contentGroups'),
  [`${ADD_CONTENT_GROUP_CATEGORIES}${FETCH_SUCCESS}`]: (state, action) =>
    updateContentGroupCategories(state, action.payload),
  [`${REMOVE_CONTENT_GROUP_CATEGORIES}${FETCH_SUCCESS}`]: (state, action) =>
    updateContentGroupCategories(state, action.payload),
  [`${GET_EVENT_LOG_ITEMS}${FETCH_SUCCESS}`]: addEventLogItems,

  [`${UPDATE_CONTENT_GROUP_META}${FETCH_SUCCESS}`]: (state, action) =>
    updateContentGroupMeta(state, action.payload),
  [`${GET_USERS}${FETCH_SUCCESS}`]: (state, action) =>
    setKey(state, action.payload.res.data.data, 'users'),
  [`${GET_EVENTS}${FETCH_SUCCESS}`]: (state, action) => addEvents(state, action.payload.res.data.data, action.payload.res.data.meta, action.payload.url && action.payload.url.includes('getEventsSlim')),
  [`${GET_EVENTS_SLIM}${FETCH_SUCCESS}`]: (state, action) => addEvents(state, action.payload.res.data.data, action.payload.res.data.meta, action.payload.url && action.payload.url.includes('getEventsSlim')),
  [`${GET_EVENTS_ANALYTICS}${FETCH_SUCCESS}`]: updateEventsAnalytics,
  [`${ADD_CONTENT_GROUP_USER}${FETCH_SUCCESS}`]: updateGroupUsers,
  [`${REMOVE_CONTENT_GROUP_USER}${FETCH_SUCCESS}`]: removeGroupUser,
  [`${DELETE_CONTENT_GROUP}${FETCH_SUCCESS}`]: deleteContentGroup,
  [`${GET_FULL_EVENT}${FETCH_SUCCESS}`]: (state, action) => addEvent(state, action.payload.res.data.data),
  [`${BUS}http.events.get.resolve`]: (state, action) => addEvents(state, action.payload.res.data, action.payload.res.meta, action.payload.url && action.payload.url.includes('getEventsSlim')),
  // The start response body is the same full event record the `events.start`
  // websocket message carries -- verified field for field against a capture of
  // both (tests/fixtures/liveControl). Applying it here moves the event to
  // `starting` a websocket hop early, so the encoder select's status check takes
  // over from its in-flight gate with no window in between. Stop has no
  // equivalent: its response body is malformed, and the status it is leaving
  // (`live`) already blocks the select on its own.
  [`${BUS}http.events.start.resolve`]: (state, action) => addEvent(state, action.payload.res && action.payload.res.data),
  [`${GET_TRANSCRIPT_VOCABULARIES}${FETCH_SUCCESS }`]: getVocabs,
  [`${UPDATE_TRANSCRIPT_VOCABULARIES}${FETCH_SUCCESS}`]: (state, action) => updateVocab(state, action.payload.res.data.data),
  [`${GET_ENCODERS}${FETCH_SUCCESS}`]: (state, action) => setKey(state, action.payload.res.data.data, 'encoders'),
  [`${BUS}ws.encoder.connect`]: (state, action) => encoderUpdate(state, action.payload.data),
  [`${BUS}ws.encoder.disconnected`]: (state, action) => encoderUpdate(state, action.payload.data),
  [`${BUS}ws.asset.add`]: (state, action) => addOrUpdateEventAsset(state, action.payload.data),
  // merge request eventID into placeholder asset to be replaced when the socket comes in
  [`${BUS}http.assets.miscAssetToEvent.resolve`]: (state, action) => addOrUpdateEventAsset(state, {...action.payload.res.data, eventID: action.payload.req.eventID, currentStatus:'placeholder'}),
  [`${GET_PLAYER_PREFERENCES}${FETCH_SUCCESS}`]: (state, action) => setKey(state, action.payload.res.data.data, 'playerPreferences'),
  [`${BUS}ws.publish.unpublish`]: (state, action) => addEvent(state, action.payload.data),
  [`${BUS}ws.events.publish`]: (state, action) => addEvent(state, action.payload.data),
  [`${BUS}ws.thumbs.update`]: (state, action) => addOrUpdateEventAsset(state, action.payload.data),
  [`${BUS}ws.eventdomrestrictions.delete`]: updateEventRestrictedDomains,
  [`${BUS}ws.eventdomrestrictions.upsert`]: updateEventRestrictedDomains,
  [`${BUS}http.streamTargets.getAltDestinations.resolve`]: (state, action) => addOrUpdateEventStreamTargets(state, action.payload.res.data),
  [`${BUS}http.transcript.getTranscriptInfo.resolve`]: (state, action) => updateEventTranscripts(state, action.payload.res.data, action.payload.req.eventID),
  [`${BUS}http.audioDescription.getProject.resolve`]: (state, action) => updateEventAudioDescription(state, action.payload.res.data)
}

const websocketHandlers = {
  [`${WEBSOCKET_DATA}users_updateuser`]: (state, action) =>
    updateUser(state, action.payload.data.users),
  [`${WEBSOCKET_DATA}users_createuser`]: (state, action) =>
    userCreated(state, action.payload.data.users),
  [`${WEBSOCKET_DATA}transcripts_createupdatevocabulary`]: (state, action) =>
    updateVocab(state, action.payload.data),
  [`${WEBSOCKET_DATA}events_update`]: (state, action) => eventWebsocketUpdate(state, action.payload.data),
  [`${WEBSOCKET_DATA}events_start`]: (state, action) => eventWebsocketUpdate(state, action.payload.data),
  [`${WEBSOCKET_DATA}events_stop`]: (state, action) => eventWebsocketUpdate(state, action.payload.data),
  [`${WEBSOCKET_DATA}events_stopping`]: (state, action) => eventWebsocketUpdate(state, action.payload.data),
  [`${WEBSOCKET_DATA}events_disconnected`]: (state, action) => eventWebsocketUpdate(state, action.payload.data),
  [`${WEBSOCKET_DATA}events_add`]: (state, action) => eventWebsocketUpdate(state, action.payload.data),
  [`${WEBSOCKET_DATA}events_delete`]: (state, action) => eventWebsocketDelete(state, action.payload.data.eventID.substring(action.payload.data.eventID.indexOf('_') + 1)),
  [`${WEBSOCKET_DATA}asset_delete`]: (state, action) => removeAssetFromEvent(state, action.payload.data.assetID, action.payload.data.eventID),
  [`${WEBSOCKET_DATA}asset_add`]: (state, action) => addOrUpdateEventAsset(state, action.payload.data),
  [`${WEBSOCKET_DATA}asset_update`]: (state, action) => addOrUpdateEventAsset(state, action.payload.data),
  [`${WEBSOCKET_DATA}thumbs_add`]: (state, action) => addOrUpdateEventAsset(state, action.payload.data),
  [`${WEBSOCKET_DATA}transcode_start`]: (state, action) => addOrUpdateEventAsset(state, action.payload.data),
  [`${WEBSOCKET_DATA}transcode_processing`]: (state, action) => updateAssetTranscodeProgress(state, action.payload.data),
  [`${WEBSOCKET_DATA}transcode_complete`]: (state, action) => addOrUpdateEventAsset(state, action.payload.data),
  [`${WEBSOCKET_DATA}eventaltdest_update`]: (state, action) => addOrUpdateEventStreamTargets(state, action.payload.data),
  [`${WEBSOCKET_DATA}eventaltdest_add`]: (state, action) => addOrUpdateEventStreamTargets(state, action.payload.data),
  [`${WEBSOCKET_DATA}eventaltdest_delete`]: (state, action) => removeEventStreamTarget(state, action.payload.data.eventID, action.payload.data.altEventStreamID),
  [`${WEBSOCKET_DATA}transcripts_setuseascaptions`]: (state, action) => updateEventTranscripts(state, action.payload.data),
  [`${WEBSOCKET_DATA}transcripts_resubmit`]: (state, action) => updateEventTranscripts(state, action.payload.data),
  [`${WEBSOCKET_DATA}transcripts_completed`]: (state, action) => updateEventTranscripts(state, action.payload.data),
  [`${WEBSOCKET_DATA}transcripts_create`]: (state, action) => updateEventTranscripts(state, action.payload.data),
  [`${WEBSOCKET_DATA}transcripts_delete`]: deleteEventTranscripts,
  [`${WEBSOCKET_DATA}ad-studio-projects_upsert`]: (state, action) => updateEventAudioDescription(state, action.payload.data),
  [`${WEBSOCKET_DATA}ad-studio-projects_delete`]: (state, action) => removeEventAudioDescription(state, action.payload.data)
}

//#endregion

const reducer = (state = getInitialState(), action) => {
  const handlers = [actionHandlers, requestHandlers, websocketHandlers]
  for (let i = 0; i < handlers.length; i++) {
    const handler = handlers[i]
    if (Object.keys(handler).includes(action.type)) {
      // console.log('redux handler:', action.type, state, action)
      return handler[action.type](state, action)
    }
  }
  return state
}

export default reducer
